import { render, staticRenderFns } from "./add-attachment-modal.vue?vue&type=template&id=70f47304&"
import script from "./add-attachment-modal.vue?vue&type=script&lang=js&"
export * from "./add-attachment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports